import { ReactNode, useState } from "react";
import { Collapse } from "react-bootstrap";

interface ResponsiveCollapseProps {
    title: string;
    isBreakPointActive: boolean;
    isOpen?: boolean;
    children: ReactNode;
}

export function ResponsiveCollapse({ title, isBreakPointActive, isOpen = false, children }: ResponsiveCollapseProps) {
    const [open, setOpen] = useState(isOpen);
    return isBreakPointActive ? (
        <>
            <button
                onClick={() => setOpen(!open)}
                aria-controls={title}
                aria-expanded={open}
                className="mb-2 p-0 cursor-pointer bg-transparent border-0"
                style={{ color: "inherit" }}
            >
                <i className={`bi ${open ? "bi-caret-down-fill" : "bi-caret-right-fill"} me-2`}></i>
                {title}
            </button>
            <Collapse in={open}>
                <div>
                    {children}
                </div>
            </Collapse>
        </>
    ) : (
        <>{children}</>
    );
}